module.exports = __webpack_public_path__ + "img/kaas.7cde8660.png";